export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/card-button-arrow.654d9d0f-1136c9.svg";